import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import BreachTable from "./BreachTable";

const BreachedCredentialsModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.open? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
		>
			<DialogTitle id="alert-dialog-title">
				Breached Accounts
			</DialogTitle>
			<DialogContent>
				<BreachTable
					breaches={props.breaches}
				/>
			</DialogContent>
		</Dialog>
	);

}

export default BreachedCredentialsModal;